import { NavLink, Navigate, Outlet, useLocation, useSearchParams } from "react-router";
import "./CdesDashboard.scss";

const CdesIndexRedirect = () => {
    const [searchParams] = useSearchParams();
    const search = searchParams.toString();
    return <Navigate to={search ? `clients?${search}` : "clients"} replace />;
};

const CdesDashboard = () => {
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();
    const clientId = searchParams.get("clientId");
    const tabSearch = clientId ? `?${new URLSearchParams({ clientId })}` : "";
    const clientsActive = pathname.startsWith("/finance/cdes/clients");
    const plansActive = pathname.startsWith("/finance/cdes/plans");
    const fieldsActive = pathname.startsWith("/finance/cdes/fields");

    return (
        <div className="container cdes-dashboard">
            <div className="cdes-dashboard__tabs" role="tablist" aria-label="CDES views">
                <NavLink
                    to={`/finance/cdes/clients${tabSearch}`}
                    role="tab"
                    aria-selected={clientsActive}
                    className={`cdes-dashboard__tab${clientsActive ? " cdes-dashboard__tab--active" : ""}`}
                >
                    Clients
                </NavLink>
                <NavLink
                    to={`/finance/cdes/plans${tabSearch}`}
                    role="tab"
                    aria-selected={plansActive}
                    className={`cdes-dashboard__tab${plansActive ? " cdes-dashboard__tab--active" : ""}`}
                >
                    Plans
                </NavLink>
                <NavLink
                    to="/finance/cdes/fields"
                    role="tab"
                    aria-selected={fieldsActive}
                    className={`cdes-dashboard__tab${fieldsActive ? " cdes-dashboard__tab--active" : ""}`}
                >
                    Fields
                </NavLink>
            </div>
            <Outlet />
        </div>
    );
};

export { CdesIndexRedirect };
export default CdesDashboard;
